import React from "react";
import ReactDOM from "react-dom";
import AppState from "../model/AppState";
import ModalObservacoes from "./ModalObservacoes";
import ListaItemModel from "../model/ListaItemModel";
import ModalListas from "./ModalListas";
import ListaModel from "../model/ListaModel";
import NavegadorUtil from "../util/NavegadorUtil";
import ProdutoModel from "../model/ProdutoModel";

type ListaItemProps = {
  item: ListaItemModel;
  listaId: string;
  parent: React.Component;
};

type ListaItemState = {
  showObservacao: boolean;
  showModalObservacoes: boolean;
  showModalLista: boolean;
  observacao: string;
};

class ListaItem extends React.Component<ListaItemProps, ListaItemState> {
  constructor(props: ListaItemProps) {
    super(props);

    this.incItem = this.incItem.bind(this);
    this.decItem = this.decItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleObservacao = this.toggleObservacao.bind(this);
    this.saveObservacoes = this.saveObservacoes.bind(this);
    this.toggleModalObservacoes = this.toggleModalObservacoes.bind(this);
    this.toggleModalLista = this.toggleModalLista.bind(this);

    this.state = {
      showObservacao: false,
      showModalObservacoes: false,
      showModalLista: false,
      observacao: this.props.item.notas,
    };
  }

  async componentDidUpdate(
    prevProps: ListaItemProps,
    prevState: ListaItemState
  ): Promise<void> {
    const lista: ListaModel = await AppState.getLista(this.props.listaId);
    const itens: ListaItemModel[] = lista.items.filter(
      (ci) => ci.produto.produtoId === prevProps.item.produto.produtoId
    );
    if (itens.length === 1) {
      if (prevState.observacao !== itens[0].notas) {
        this.setState({ observacao: itens[0].notas });
      }
    }
  }

  incItem(): any {
    this.props.parent.setState({ carregando: true });
    AppState.incListaItem(
      this.props.listaId,
      this.props.item.produto,
      this.props.item.notas
    ).then((r) => {
      if (this.props.listaId) {
        AppState.getLista(this.props.listaId).then(
          (lista: ListaModel) => {
            NavegadorUtil.alerta(
              this.props.parent,
              "Quantidade atualizada com sucesso"
            );
            this.props.parent.setState({ lista, carregando: false });
          }
        );
      }
    });
  }

  decItem(): any {
    this.props.parent.setState({ carregando: true });
    AppState.decListaItem(
      this.props.listaId,
      this.props.item.produto,
      this.props.item.notas
    ).then((msg) => {
      if (this.props.listaId) {
        AppState.getLista(this.props.listaId).then(
          (lista: ListaModel) => {
            NavegadorUtil.alerta(
              this.props.parent,
              msg
            );
            this.props.parent.setState({ lista, carregando: false });
          }
        );
      }
    });
  }

  async removeItem(): Promise<any> {
    const { listaId, item, parent } = this.props;
    await AppState.remListaItem(listaId, item.produto);
    AppState.getLista(this.props.listaId).then(
      (lista: ListaModel) => {
        NavegadorUtil.alerta(parent, "Produto removido com sucesso !");
        this.props.parent.setState({ lista, carregando: false });
      }
    );
  }

  toggleMenu(): any {
    const item: any = ReactDOM.findDOMNode(this.refs.itemRef);
    item.classList.toggle("menu");
  }

  toggleObservacao(): any {
    this.setState({ showObservacao: !this.state.showObservacao });
    const seta: any = ReactDOM.findDOMNode(this.refs.seta);
    seta.classList.toggle("fa-chevron-down");
    seta.classList.toggle("fa-chevron-up");
  }

  saveObservacoes(obs: string): void {
    AppState.setListaItemNota(
      this.props.listaId,
      this.props.item.produto.produtoId,
      obs
    );

    this.setState({ observacao: obs });
    this.toggleModalObservacoes();
    this.props.parent.forceUpdate();
  }

  toggleModalObservacoes(): void {
    this.setState({ showModalObservacoes: !this.state.showModalObservacoes });
  }

  toggleModalLista(): void {
    this.setState({ showModalLista: !this.state.showModalLista });
  }

  render(): any {
    const { item } = this.props;

    let prodPrecoDesconto: number = item.produto.precoDesconto;

    if (item.produto.unidade === "GR") {
      prodPrecoDesconto =
        (item.produto.precoDesconto / 1000) * item.produto.fatorMultiplicacao;
    }

    return (
      <li className="item" ref="itemRef">
        <div className="product">
          <div className="info">
            <div className="photo">
              <img
                src={item.produto.imagem}
                alt={item.produto.nome}
                title={item.produto.nome}
              />
            </div>
            <div className="details">
              <p className="upper">{item.produto.marca}</p>
              <p className="middle">{item.produto.nome}</p>
              <p className="bottom">
                {`R$ ${prodPrecoDesconto.toFixed(2).replace(".", ",")}`}
                <span> ({ProdutoModel.getGR(item.produto)})</span>
              </p>
            </div>
            <div className="menu">
              <div className="items">
                <div className="total">
                  { item.produto.unidade === "GR" &&
                  <div className="price">
                    R$ {(item.produto.precoDesconto * item.produto.fatorMultiplicacao / 1000 * item.quantidade).toFixed(2).replace(".", ",")}<br/>
                    <span>{ProdutoModel.getGR(item.produto, item.quantidade)}</span>
                  </div>
                  }
                  { item.produto.unidade !== "GR" &&
                  <div className="price">
                    R$ {(item.produto.precoDesconto * item.quantidade).toFixed(2).replace(".", ",")}<br/>
                  </div>
                  }
                  <div>
                    { item.produto.precoDesconto < item.produto.precoOriginal &&
                    <div className="sale">
                      -{(
                        100 -
                        (item.produto.precoDesconto / item.produto.precoOriginal) * 100
                      ).toFixed(0)}%
                    </div>
                    }
                  </div>
                </div>
                <div>
                    <button onClick={this.decItem} className="remove">
                      -
                    </button>
                    <div className={ `qty`} onClick={ () => { this.incItem() }}>{item.quantidade}</div>
                    <button onClick={this.incItem} className="add">
                      +
                    </button>
                  </div>
              </div>
              <i
                className="icon fas fa-chevron-left"
                onClick={this.toggleMenu}
              ></i>
            </div>
          </div>
          <div className="actions">
            <button className="rem" onClick={this.removeItem}>
              <img
                src={NavegadorUtil.getUrl(
                  `${process.env.PUBLIC_URL}/assets/images/icons/menu/trash.svg`
                )}
                alt="Remover produto"
              />
              Remover produto
            </button>
            <button className="add" onClick={this.toggleModalLista}>
              <img
                src={NavegadorUtil.getUrl(
                  `${process.env.PUBLIC_URL}/assets/images/icons/menu/check-square.svg`
                )}
                alt="Adicionar a uma lista"
              />
              Adicionar a uma lista
            </button>
            <button className="obs" onClick={this.toggleModalObservacoes}>
              <img
                src={NavegadorUtil.getUrl(
                  `${process.env.PUBLIC_URL}/assets/images/icons/menu/edit.svg`
                )}
                alt="Adicionar observação"
              />
              Adicionar observação
            </button>
          </div>
        </div>
        <div className="notes">
          <div 
            className="notes-title"
            onClick={this.toggleObservacao}
          >
            <div className="detail">OBSERVACÕES</div>
            <i className="icon fas fa-chevron-down" ref="seta"></i>
          </div>
          {this.state.showObservacao && (
            <>
              {item.notas && item.notas.length > 0 && (
                <p className="notes-text">{item.notas}</p>
              )}
              {(!item.notas || (item.notas && item.notas.length === 0)) && (
                <p className="notes-text">
                  <i>Nenhuma observação informada</i>
                </p>
              )}
            </>
          )}
        </div>
        <ModalListas
          produto={item.produto}
          toggleModalLista={this.toggleModalLista}
          visivel={this.state.showModalLista}
          parent={this.props.parent}
        ></ModalListas>
        <ModalObservacoes
          observacao={item.notas}
          visivel={this.state.showModalObservacoes}
          save={this.saveObservacoes}
          hide={this.toggleModalObservacoes}
        ></ModalObservacoes>
      </li>
    );
  }
}

export default ListaItem;
